import { get } from 'core_main/request';
import { updateStore } from 'core_main/store';
import { makeGetChatSettingsEndpoint } from './helpers';
import { FetchSettingsParameters } from './types';

export const fetchSettings = (parameters: FetchSettingsParameters) => {
  return get(
    makeGetChatSettingsEndpoint({
      brandId: parameters.brandId,
      lang: parameters.lang,
    }),
  ).then((response) => {
    const {
      enabled,
      sharedPubNubKeySet,
      teamIconUrl,
      embedIconUrl,
      embedIconColor,
      teamName,
      waitMessage,
      greeting,
      singleSessionChat,
      noHistory,
      offhoursImageUrl,
      offhoursMessage,
      offhoursDisplay,
      closableChat,
      showTypingIndicatorCustomerWeb,
      showTypingIndicatorWeb,
      volumeControl,
      domainCriteria,
      widgetType,
      activeAssistant,
      colors,
      showBrandingIdentifier,
    } = response?.data?.attributes;

    const { id: orgId } = response.data.relationships.org.data;
    const brandId = response?.data?.relationships?.brand?.data?.id;
    const knowledgeBaseId = response?.data?.relationships?.kb?.data?.id;

    updateStore('settings', {
      enabled,
      sharedPubNubKeySet,
      teamIconUrl,
      embedIconUrl,
      embedIconColor,
      teamName,
      waitMessage,
      greeting,
      singleSessionChat,
      noHistory,
      offhoursImageUrl,
      offhoursMessage,
      offhoursDisplay,
      closableChat,
      showTypingIndicatorCustomerWeb,
      showTypingIndicatorWeb,
      volumeControl,
      domainCriteria,
      widgetType,
      activeAssistant,
      colors,
      showBrandingIdentifier,
      brandId,
      knowledgeBaseId,
    });

    updateStore('orgId', orgId);

    return response;
  });
};
